export const ProductCardImageInputConfig = {
  smSize: { width: 312, height: 390 },
  mdSize: { width: 320, height: 400 },
  lgSize: { width: 360, height: 450 },
  xlSize: { width: 448, height: 560 },
};
